export default "__VITE_ASSET__a4eedfeb__"